import './App.css';

import Router from './Router/Router';

import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (

    <div className="App">
      <Router />
    </div>
  );
}

export default App;
